export default __webpack_public_path__ + "static/media/timeline-point.7b78ac21.svg";